import {
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { BehaviorSubject, Observable, Subscription } from "rxjs";
import { Media } from "../../model/media";
import { Messages } from "../../model/messages";
import { MediaService } from "../../services/media.service";
import { AuthService } from "../../auth.service";
import { Router } from "@angular/router";
import { NavigationHelper } from "../../services/navigation.helper";
import { Navigation } from "../../model/navigation";
import { ActionButtonSubmit } from "../../model/action-button-submit";
import { TicketService } from "../../services/ticket.service";
import { Ticket } from "../../model/ticket";
import { environment } from "../../../environments/environment";
import { HttpClient } from "@angular/common/http";

import { DomSanitizer, SafeUrl } from "@angular/platform-browser";

@Component({
  selector: "media-details",
  templateUrl: "./media-details.component.html",
  styleUrls: ["./media-details.component.css"],
})
export class MediaDetailsComponent implements OnInit, OnDestroy {
  messages = new BehaviorSubject<Messages>(Messages.EMPTY);
  media = new BehaviorSubject<Media>(Media.EMPTY);
  editMode: boolean = false;
  mediaForm: FormGroup;
  mediaTitle: string = "mediaDetails.title.media.details";
  @Input() currentTicket: Observable<Ticket>;
  ticket: Ticket | null = null;
  currentId: number | null = null;
  selectedFile: File | null = null;

  isDownloading: boolean = false;
  downloadComplete: boolean = false;
  public imageUrl = new BehaviorSubject<SafeUrl | null>(null);
  isLoading: boolean = false;
  isModalOpen: boolean = false;
  modalImage: SafeUrl | null = null;

  @ViewChild("fileInput") fileInput: ElementRef<HTMLInputElement>;
  completionUrl = new BehaviorSubject<string>("");
  private selectedMediaSubscription: Subscription;
  private subscription: Subscription;
  constructor(
    private ticketService: TicketService,
    private mediaService: MediaService,
    private auth: AuthService,
    private fb: FormBuilder,
    private router: Router,
    private nav: NavigationHelper,
    private http: HttpClient,

    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.initializeForm();

    const savedState = localStorage.getItem("mediaState");
    if (savedState) {
      const state = JSON.parse(savedState);
      if (state.url === this.router.url) {
        this.editMode = state.editMode;
        this.mediaTitle = this.editMode
          ? "mediaDetails.title.new"
          : "mediaDetails.title.media.details";

        if (state.selectedFileName) {
        }
      }
    }

    if (this.currentTicket) {
      this.currentTicket.subscribe((ticket) => {
        this.currentId = ticket.id;
        this.ticket = ticket;
        if (this.currentId === null) {
          this.previewImage();
        }
      });
    }

    if (Navigation.NEW.toString() === this.nav.currentId) {
      this.editMode = true;
      this.mediaForm.reset();
      this.mediaTitle = "mediaDetails.title.new";
    }

    if (!this.selectedMediaSubscription) {
      this.selectedMediaSubscription =
        this.mediaService.selectedMediaObservable.subscribe((selectedMedia) => {
          if (selectedMedia) {
            this.populateForm(selectedMedia);
            this.completionUrl.next(
              "tickets/" +
                this.currentId +
                "/fragmentedit/media/" +
                selectedMedia.id
            );
          }
        });
    } else {
    }
    if (!this.mediaService.currentMedia?.id) {
      this.mediaService.selectFromRouter();
    }

    if (
      this.isImage(this.media.value.contentType) &&
      this.media.value.fileInfo?.path
    ) {
      this.previewImage();
    }

    this.nav.fragmentId.subscribe((id) => {
      const nav = this.nav.current;
      if (nav.fragmentTopic === "media" && (id === "-9" || Number(id) > 0)) {
        const fragmentId = Number(id);

        if (fragmentId > 0) {
          const action = nav.action;

          if (action === "fragment") {
            this.editMode = false;
          } else if (
            action === "fragmentedit" &&
            fragmentId === Navigation.NEW
          ) {
            this.editMode = true;
          } else if (action === "fragmentedit") {
            this.editMode = true;
          }
        }
      }
    });
  }

  private initializeForm(): void {
    this.mediaForm = this.fb.group({
      name: "",
      remark: "",
      fileInfo: null,
    });
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.selectedFile = file;
      this.mediaForm.patchValue({
        name: file.name,
        remark: "upload",
      });

      const currentState = {
        url: this.router.url,
        editMode: this.editMode,
        selectedFileName: file.name,
      };
      localStorage.setItem("mediaState", JSON.stringify(currentState));
    }
  }

  private populateForm(media: Media): void {
    this.media.next(media);
    this.mediaForm.patchValue({
      name: media.name,
      remark: media.remark,
    });
    this.editMode = media.id === Navigation.NEW;
    this.mediaTitle = this.editMode
      ? "mediaDetails.title.new"
      : "mediaDetails.title.media.details";
  }

  toggleEditMode(): void {
    if (this.editMode) {
      this.editMode = false;
      this.media.next(Media.EMPTY);
      this.mediaForm.reset();
      this.mediaTitle = "mediaDetails.title";
      this.clearState();
    } else {
      this.router.navigate([
        "tickets/" + this.currentId + "/fragmentedit/media/" + this.mediaId,
      ]);
      this.editMode = true;
    }
  }
  saveMedia(action: ActionButtonSubmit): void {
    this.isLoading = true;
    if (this.mediaForm.valid) {
      const token = this.auth?.token;
      const id = this.media.value.id;
      const ticketId = this.currentId;

      if (ticketId == null) {
        return;
      }

      const updatedMedia = new Media(
        id && id >= 1 ? id : Navigation.NEW,
        this.mediaForm.value.name || "",
        ticketId,
        this.mediaForm.value.remark || "",
        this.mediaForm.value.uploadedBy || 0,
        this.mediaForm.value.archived || false,
        this.mediaForm.value.fileInfo || null,
        this.mediaForm.value.contentType || "",
        this.mediaForm.value.extension || "",
        this.mediaForm.value.original || ""
      );

      const formData = new FormData();
      formData.append("name", updatedMedia.name);
      formData.append("ticketId", ticketId.toString());
      formData.append("remark", updatedMedia.remark || "");

      if (this.selectedFile) {
        formData.append("upload", this.selectedFile, this.selectedFile.name);
      }
      if (updatedMedia.id === null || updatedMedia.id < 1) {
        this.mediaService
          .uploadMedia(token, updatedMedia, formData)
          .subscribe((messages) => {
            this.receiveMedia(messages, action, ticketId, token);
            if (this.fileInput) {
              this.fileInput.nativeElement.value = "";
            }
            this.selectedFile = null;
          });
      }
    }
  }
  receiveMedia(
    messages: Messages,
    action: ActionButtonSubmit,
    ticketId: number,
    token: string
  ) {
    this.isLoading = false;
    this.messages.next(messages);
    if (messages.hasAnyMessages) {
      action.result(false);
    } else {
      action.result(true);

      this.ticketService
        .getTicketWithParts(token, ticketId, this.ticket || undefined)
        .subscribe((messages) => {
          this.messages.next(messages);
        });
      const media = this.mediaService.currentMedia;
      const mediaId: number = media.id;
      const url = "tickets/" + this.currentId + "/fragment/media/" + mediaId;
      this.router.navigate([url]);
    }
  }

  deleteMedia(): void {
    const token = this.auth.token;
    const mediaId = this.media.value.id;
    const ticketId = this.currentId;

    if (mediaId && ticketId) {
      this.mediaService.deleteMedia(token, ticketId, mediaId).subscribe(
        (response) => {
          this.messages.next(response);
          this.media.next(Media.EMPTY);
        },
        (error) => {
          this.messages.next(
            Messages.from({ status: ["media.delete.failed"] })
          );
        }
      );
    }
  }
  clearState(): void {
    localStorage.removeItem("mediaState");
  }
  isImage(contentType: string | undefined | null): boolean {
    return contentType ? contentType.startsWith("image/") : false;
  }

  downloadMedia(): void {
    const url = this.getMediaDownloadUrl();
    if (!url) {
      return;
    }
    const token = this.auth.token;
    if (!token) {
      return;
    }
    this.isDownloading = true;
    this.downloadComplete = false;
    this.http
      .get(url, {
        responseType: "blob",
        headers: { Authorization: `Bearer ${token}` },
      })
      .subscribe({
        next: (blob) => {
          const fileName =
            this.media.value.fileInfo?.fileName || "downloaded-file";
          const downloadUrl = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = downloadUrl;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(downloadUrl);
          this.downloadComplete = true;
        },
        error: (err) => {
          this.messages.next(
            Messages.from({ status: ["media.download.failed"] })
          );
        },
        complete: () => {
          this.isDownloading = false;
        },
      });
  }
  previewImage(): void {
    const url = this.getMediaDownloadUrl();
    const token = this.auth.token;
    if (!token) {
      return;
    }
    this.mediaService
      .downloadAuthenticatedMediaUrl(url, token, this.imageUrl)
      .subscribe((messages) => {
        if (!messages.empty) {
        }
      });
  }

  getMediaDownloadUrl(): string {
    if (
      !this.currentId ||
      !this.media.value.id ||
      !this.media.value.fileInfo?.fileName
    ) {
      return "";
    }
    return `${environment.API_BASE_URL}media/for-ticket/${this.currentId}/download/${this.media.value.id}/${this.media.value.fileInfo.fileName}`;
  }
  openImageModal(): void {
    if (this.imageUrl.value) {
      this.isModalOpen = true;
      this.modalImage = this.imageUrl.value;
    }
  }

  closeImageModal(): void {
    this.isModalOpen = false;
    this.modalImage = null;
  }

  ngOnDestroy(): void {
    const currentUrl = this.imageUrl.getValue();
    if (currentUrl instanceof String) {
      window.URL.revokeObjectURL(currentUrl as string);
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.selectedMediaSubscription) {
      this.selectedMediaSubscription.unsubscribe();
    }
  }
  get TRUE(): boolean {
    return true;
  }
  get FALSE(): boolean {
    return false;
  }
  get mediaId(): number {
    const media = this.media.value;
    return media && media.id ? media.id : Navigation.NEW;
  }
}
